import React from 'react';
import { SectionCta } from '../SectionCta';
import { AUTHOR_URL } from '../../data/content';
export function Author() {
  return <section className="bg-ink-900 px-4 py-16 text-white md:px-8 md:py-24" data-id="element-59" data-mp="1htc411tlj5e3">
      <div className="mx-auto grid max-w-5xl items-center gap-10 md:grid-cols-[0.85fr_1fr] md:gap-14" data-id="element-60" data-mp="1whqgm4gte87u">
        <div className="mx-auto w-full max-w-sm overflow-hidden rounded-3xl ring-4 ring-brand-400" data-id="element-61" data-mp="1rox9xb1scpt4">
          <img src={AUTHOR_URL} alt="Dr. Valeria Montes in her dental clinic" className="aspect-[4/5] w-full object-cover object-top" loading="lazy" data-id="element-62" data-mp="25gbsjgrs6ozn" />
        </div>
        <div data-id="element-63" data-mp="2ff9hulx16mjp">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-300" data-id="element-64" data-mp="2fg2ntko6180s">
            Created for dental professionals who value structured clinical reasoning
          </p>
          <h2 className="mt-3 text-[32px] font-extrabold leading-tight tracking-tight md:text-[42px]" data-id="element-65" data-mp="l18h1vhx7pgz">
            By Dr. Valeria Montes
          </h2>
          <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-mist-200" data-id="element-66" data-mp="g49qfmxgu0nj">
            <p data-id="element-67" data-mp="3gfnpvdj4b6r4">
              The Endodontic Retreatment Decision Blueprint™ is presented by Dr. Valeria Montes as a practical clinical
              organization resource.
            </p>
            <p data-id="element-68" data-mp="3pdzq879sdiwr">
              Its purpose is to help qualified dental professionals bring greater structure to the way they assess,
              document, and plan complex endodontic retreatment cases.
            </p>
            <p data-id="element-69" data-mp="2yy70pk32h6r">
              The framework emphasizes systematic information organization, individualized clinical judgment, and clear
              professional documentation.
            </p>
          </div>
          <p className="mt-6 border-l-4 border-cta-400 pl-4 text-sm leading-relaxed text-mist-300" data-id="element-70" data-mp="c0xofiz0fna8">
            This resource is intended for qualified dental professionals. It does not replace clinical training,
            professional judgment, current evidence, or applicable standards of care.
          </p>
          <SectionCta label="Get Dr. Montes' blueprint now" tone="dark" data-id="element-71" data-mp="2isfdc813h819" />
        </div>
      </div>
    </section>;
}